angular.module('app').controller('GamesCasinoJackpotBannersController', [
  '$scope',
  '$cookies',
  '$rootScope',
  '$timeout',
  'preloadedPages',
  'pagesService',
  'errorHandler',
  'logger',
  'settingsService',
  'preloadedPageNames',
  'Utils',
  function ($scope, $cookies, $rootScope, $timeout, preloadedPages, pagesService, errorHandler, logger, settingsService, preloadedPageNames, Utils) {
      var settings = settingsService.getSettings();
      $scope.selectedLanguage = $rootScope.env.lang || $cookies.get('preferedLanguage') || settings.skin.defaultLang;
      $scope.addedMenus = {};
      var initialData;
      $scope.addingMenuName = '';
      $scope.languages = settings.skin.languages;
      var pageNameTitleMap = {};

      /**
       * Init page names
       */
      function initPageNames(pageNamesPrsponse) {
        $scope.pageNames = angular.copy(pageNamesPrsponse.pageNames);
        $scope.usedPageNames = {};
        pageNameTitleMap = {};
        var pageNamesLength = $scope.pageNames.length;
        for (var j = 0; j < pageNamesLength; ++j) {
          var pageName = $scope.pageNames[j];
          pageNameTitleMap[pageName.name] = pageName.title;
          if (pageNamesPrsponse.used.indexOf(pageName.id) !== -1) {
            $scope.usedPageNames[pageName.id] = true;
          }
          if ($scope.addedMenus[$scope.selectedLanguage]) {
            var addedMenusLength = $scope.addedMenus[$scope.selectedLanguage].length;
            for (var i = 0; i < addedMenusLength; ++i) {
              var addedPageName = $scope.addedMenus[$scope.selectedLanguage][i];
              if (addedPageName.name === pageName.name) {
                $scope.addedMenus[$scope.selectedLanguage][i] = pageName;
                break;
              }
            }
          }
        }
      }

      initPageNames(preloadedPageNames);

      /**
       * Change menu item if it is not selected
       * @param menuItem
       */
      $scope.changeMenu = function (menuItem) {
        if (!$scope.activePage || menuItem.name !== $scope.activePage.name) {
          selectMenu(menuItem);
        }
      };


      function extractCustomFields(customFields) {
        var customFieldsArray = customFields.children || customFields;
        var length = customFieldsArray.length;
        $scope.activePage.size = {};
        for (var i = 0; i < length; ++i) {
          var customField = customFieldsArray[i];
          switch (customField.key) {
            case 'background-color': {
              $scope.activePage.backgroundColor = customField.value;
              break;
            }
            case 'text-color': {
              $scope.activePage.textColor = customField.value;
              break;
            }
          }
        }
        $scope.activePage.backgroundColor = $scope.activePage.backgroundColor || '';
        $scope.activePage.textColor = $scope.activePage.textColor || '';
      }

      /**
       * Select menu item
       * @param menuItem
       */
      function selectMenu(menuItem) {
        $scope.imageToLoad = null;
        $scope.$emit('force:reset:editor');
        $scope.draggedImageDataUrl = $scope.draggedImage = undefined;
        if (menuItem.page) {
          $scope.activePage = angular.copy(menuItem.page);
          $scope.activePage.isActive = $scope.activePage.status === 'published';
          $scope.initialImage = $scope.activePage.image;
          extractCustomFields($scope.activePage.customFields);
          initialData = angular.copy($scope.activePage);
        } else {
          $scope.activePage = {
            name: menuItem.name,
            title: menuItem.title,
            isActive: true,
            image: '',
            backgroundColor: '',
            textColor: '',
            content: ''
          };
        }
      };

      function initMenu(pages) {
        $scope.menu = [];
        var pagesLength = pages.length;
        var isSelected = false;
        for (var i = 0; i < pagesLength; ++i) {
          var page = pages[i];
          var item = {};
          item.id = page.id;
          item.title = pageNameTitleMap[page.name];
          item.page = page;
          item.name = page.name;
          $scope.menu.push(item);
          if ($scope.activePage && page.name === $scope.activePage.name) {
            selectMenu(item);
            isSelected = true;
          }
        }
        var addedMenuseLength = $scope.addedMenus[$scope.selectedLanguage] ? $scope.addedMenus[$scope.selectedLanguage].length : 0;
        for (var j = 0; j < addedMenuseLength; ++j) {
          var pageName = $scope.addedMenus[$scope.selectedLanguage][j];
          var item = {};
          item.title = pageName.title;
          item.name = pageName.name;
          $scope.menu.push(item);
          if ($scope.activePage && !isSelected && pageName.name === $scope.activePage.name) {
            selectMenu(item);
            isSelected = true;
          }
        }
        $scope.menu.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        if (!isSelected) {
          if ($scope.menu.length === 0) {
            $scope.activePage = undefined;
          } else {
            selectMenu($scope.menu[0]);
          }
        }
      }

      initMenu(preloadedPages);

      /**
       * Update adding menu name chosen
       */
      $scope.updateAddingMenuChosen = function updateAddingMenuChosen() {
        $timeout(function () {
          $('#addingMenuName').trigger('chosen:updated');
        }, 50);
      };


      /**
       * Load selected language data
       */
      $scope.languageChangeHandler = function languageChangeHandler() {
        $scope.addmode = false;
        var filters = {
          lang: $scope.selectedLanguage,
          pageType: 'live-casino-jackpots',
          page_id: 0
        };
        $rootScope.env.lang = $scope.selectedLanguage;
        Utils.saveEnvToStorage();
        pagesService.getPagesNames(filters).then(
            function (pageNamesResponse) {
              initPageNames(pageNamesResponse);
              var pageFilters = {
                lang: $scope.selectedLanguage,
                limit: 25,
                type: 'live-casino-jackpots'
              };
              pagesService.getPages(pageFilters).then(
                  function (pagesResponse) {
                    initMenu(angular.copy(pagesResponse.pages));
                    $scope.updateAddingMenuChosen();
                  },
                  function (error) {
                    errorHandler(error.message);
                    return null
                  }
              )
            },
            function (error) {
              errorHandler(error.message);
              return null
            }
        );
      };


      /**
       * Add menu item
       */
      $scope.addMenu = function addMenu() {
        var pageNamesLength = $scope.pageNames.length;
        for (var i = 0; i < pageNamesLength; ++i) {
          var pageName = $scope.pageNames[i];
          if ($scope.addingMenuName === pageName.name) {
            $scope.addedMenus[$scope.selectedLanguage] = $scope.addedMenus[$scope.selectedLanguage] || [];
            $scope.addedMenus[$scope.selectedLanguage].push(pageName);
            var item = {};
            item.title = pageName.title;
            item.name = pageName.name;
            $scope.menu.push(item);
            break;
          }
        }
        $scope.menu.sort(function (a, b) {
          return a.name.localeCompare(b.name);
        });
        if (!$scope.activePage) {
          selectMenu($scope.menu[0]);
        }
        $scope.updateAddingMenuChosen();
        $scope.addingMenuName = '';
      };


      /**
       * Remove new added menu
       */
      $scope.removeMenu = function removeMenu(menu) {
        $scope.menu.splice($scope.menu.indexOf(menu), 1);
        $scope.addedMenus[$scope.selectedLanguage] = $scope.addedMenus[$scope.selectedLanguage].filter(function (item) {
          return item.name !== menu.name;
        });
        if ($scope.activePage.name === menu.name) {
          if ($scope.menu.length > 0) {
            selectMenu($scope.menu[0]);
          } else {
            $scope.activePage = undefined;
          }
        }
        $scope.updateAddingMenuChosen();
      };

      /**
       * Delete background icon callback
       */
      $scope.deleteImage = function deleteImage() {
        $scope.activePage.image = false;
        $scope.imageToLoad = null;
        $scope.draggedImageDataUrl = $scope.draggedImage = undefined;
      };


      function createAddRequestData(dataURL) {
        var requestData = {
          title: $scope.activePage.title,
          name: $scope.activePage.name,
          status: $scope.activePage.isActive ? 'published' : 'archive',
          type: 'live-casino-jackpots',
          lang: $scope.selectedLanguage,
          options: {
            'background-color': $scope.activePage.backgroundColor,
            'text-color': $scope.activePage.textColor
          },
          content: $scope.activePage.content
        };
        if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl) {
          requestData.media_id = $scope.imageToLoad.id;
        } else if (dataURL) {
          requestData.image = dataURL;
        }
        return [requestData];
      }

      function createEditRequestData(dataUrl) {
        var requestData = {
          id: $scope.activePage.id,
          title: $scope.activePage.title,
          name: $scope.activePage.name,
          status: $scope.activePage.isActive ? 'published' : 'archive',
          type: 'live-casino-jackpots',
          lang: $scope.selectedLanguage,
          options: {
            'background-color': $scope.activePage.backgroundColor,
            'text-color': $scope.activePage.textColor
          },
          content: $scope.activePage.content
        };
        if (!!$scope.imageToLoad && !!$scope.imageToLoad.fileUrl) {
          requestData.media_id = $scope.imageToLoad.id;
        } else if (dataUrl && dataUrl.indexOf('data:image') > -1) {
          requestData.image = dataUrl;
        } else if ($scope.draggedImageDataUrl === undefined) {
          if ($scope.initialImage && !dataUrl) {
            requestData.image = false;
          }
        }
        return [requestData];

      }

      function isChanged() {
        return ($scope.draggedImage && $scope.draggedImage.lastModified) || $scope.imageToLoad || !angular.equals($scope.activePage, initialData);
      }

      /**
       * Add or edit background page
       */
      $scope.save = function save() {

        if (!$scope.activePage.id) {
          pagesService.editPage(createAddRequestData($scope.activePage.image)).then(function (response) {
                if (response.status == 'ok') {
                  logger.logSuccess('global.saved');
                  $scope.addedMenus[$scope.selectedLanguage] = $scope.addedMenus[$scope.selectedLanguage].filter(function (item) {
                    return item.name !== $scope.activePage.name;
                  });
                  $scope.languageChangeHandler();
                } else {
                  errorHandler(response.message)
                }
              },
              function (response) {
                errorHandler(response.message)
              }
          );
        } else {
          if (!isChanged()) {
            logger.logError('global.no_changes');
            return;
          } else {
            pagesService.editPage(createEditRequestData($scope.activePage.image)).then(function (response) {
                  if (response.status == 'ok') {
                    logger.logSuccess('global.saved');
                    var pageFilters = {
                      lang: $scope.selectedLanguage,
                      limit: 25,
                      type: 'live-casino-jackpots'
                    };
                    pagesService.getPages(pageFilters).then(
                        function (pagesResponse) {
                          var menuLength = $scope.menu.length;
                          for (var i = 0; i < menuLength; ++i) {
                            var menu = $scope.menu[i];
                            if (menu.name === $scope.activePage.name) {
                              var pagesLength = pagesResponse.pages.length;
                              for (var j = 0; j < pagesLength; ++j) {
                                var page = pagesResponse.pages[j];
                                if (page.name === $scope.activePage.name) {
                                  menu.page = page;
                                  selectMenu(menu);
                                  break;
                                }
                              }
                              break;
                            }

                          }
                          $scope.updateAddingMenuChosen();
                        },
                        function (error) {
                          errorHandler(error.message);
                          return null
                        }
                    )
                  } else {
                    errorHandler(response.message)
                  }
                },
                function (response) {
                  errorHandler(response.message)
                }
            );
          }
        }
      };


      $scope.load = function (dataUrl) {
        $scope.activePage.image = dataUrl;
        $timeout(function () {
          $scope.$apply();
        });
      };

      $scope.$on('image:uploaded', function () {
        $scope.imageToLoad = null;
      })


    }
]);
